import * as actions from "actions/user";

export default (state = false, { type }) => {
  switch (type) {
    case actions.FETCH_ONE:
      return true;
    case actions.FETCH_ONE_FAILED:
    case actions.FETCH_ONE_SUCCESS:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user/isFetching.js